<template>
  <div class="apply-form__section apply-form__documents">
    <ValidationObserver>
      <v-row>
        <v-col
          v-if="defaultTypes[applicationFileType.CV]"
          cols="12"
          md="6"
          class="d-flex align-center"
        >
          <template>
            <ValidationProvider
              v-slot="validationData"
              name="cv_file"
              mode="eager"
              slim
              :rules="'required|fileUploaded'"
            >
              <file-input
                :label="$t('application.cv') + '*'"
                :accept="allowedFileTypes"
                :upload-endpoint="'application-file'"
                :download-endpoint="'application-file'"
                :name="'cv_file'"
                :validation-data="validationData"
                :file-prefix="formId"
                v-model="defaultTypeModels[applicationFileType.CV]"
              ></file-input>
            </ValidationProvider>
          </template>
        </v-col>

        <v-col
          v-if="defaultTypes[applicationFileType.Letter]"
          cols="12"
          md="6"
          class="d-flex align-center"
        >
          <template>
            <ValidationProvider
              v-slot="validationData"
              name="letter_file"
              mode="eager"
              slim
              :rules="'required|fileUploaded'"
            >
              <file-input
                :label="$t('application.letter') + '*'"
                :accept="allowedFileTypes"
                :upload-endpoint="'application-file'"
                :download-endpoint="'application-file'"
                :name="'letter_file'"
                :validation-data="validationData"
                :file-prefix="formId"
                v-model="defaultTypeModels[applicationFileType.Letter]"
              ></file-input>
            </ValidationProvider>
          </template>
        </v-col>
      </v-row>

      <v-row>
        <!-- can not use the enum here, since there is a missmatch between the image value in hp.careerportal and hp.web -->
        <v-col
          v-if="defaultTypes[4]"
          cols="12"
          md="6"
          class="d-flex align-center"
        >
          <template>
            <ValidationProvider
              v-slot="validationData"
              name="image_file"
              mode="eager"
              slim
              :rules="'required|fileUploaded'"
            >
              <file-input
                :label="$t('application.image') + '*'"
                :accept="allowedFileTypes"
                :upload-endpoint="'application-file'"
                :download-endpoint="'application-file'"
                :name="'image_file'"
                :validation-data="validationData"
                :file-prefix="formId"
                v-model="defaultTypeModels[4]"
              ></file-input>
            </ValidationProvider>
          </template>
        </v-col>
      </v-row>
    </ValidationObserver>
  </div>
</template>

<script>
import fileInput from '../../file-input.vue';
import applicationFileType from '@/enum/application-file-type';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

export default {
  components: {
    fileInput,
    ValidationObserver,
    ValidationProvider
  },

  props: {
    defaultTypes: {
      type: Object,
      required: false,
      default: () => ({})
    },
    formId: {
      type: String,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    allowedFileTypes: {
      type: String,
      required: true
    }
  },

  computed: {
    applicationFileType() {
      return applicationFileType.ApplicationFileTypes;
    },
    defaultTypeModels: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>
